import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article18() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';

      return "";
    }

  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article19');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article17');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article18-left-img1.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article18-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <h1 className="fs-xl f-lora mb-4 mb-sm-5">Experiencing <br/>Scottish Traditions <br/><span className="f-lora-i">through local events</span></h1>

              <p className="">Scotland might be famous for its spectacular scenery and dramatic history, but there’s much more to enjoy here if you look a little deeper. A rich cultural heritage can be found that goes far beyond haggis and bagpipes, especially for those willing to head off the beaten path. </p>

              <p className="mb-4 mb-sm-5">Spread across Scotland’s towns and villages are a wide range of unique traditional events, some centuries old, having been passed down through generations, while others are more modern incarnations. They range from well-known celebrations to slightly obscure activities, but one thing they all have in common is the immense feeling of pride that they bring to local communities. </p>

              <h4 className="f-lora mb-3 fs-md">The Stonehaven Fireballs </h4>
              <p className="mb-3">One of the more famous local traditions found around Scotland is the Fireballs at Stonehaven. This Hogmanay tradition takes place once midnight has passed, with around 45 locals marching through the town, rhythmically swinging a ball of flames around their heads. </p>
              <p className="mb-3">Each participant makes their own ball from wire mesh, filled with flammable material. It has to burn long enough to reach the climax of the night, otherwise the holder may never be able to show their face around Stonehaven again! </p>
              <p className="mb-4 mb-sm-5">Eventually, once the procession reaches the harbour, a last big effort sees the burning mass launched into the water to be extinguished. Written records might only track the Fireballs back roughly 150 years, but using fire to cleanse away the past year is a tradition that’s much older. </p>

              <h4 className="f-lora mb-3 fs-md">The World Porridge Championships </h4>
              <p className="mb-3">With such an impressive natural larder, traditional food is a huge part of Scottish culture. Even the humble bowl of porridge deserves its place in the spotlight and for the last 30 years, Carrbridge has hosted the World Porridge Making Championships. </p>
              <p className="mb-4 mb-sm-5">Chefs from around the globe compete for the Golden Spurtle, creating the best bowl of porridge from just oats, water and salt. A second speciality category allows competitors’ imaginations to run wild with variations on the traditional recipe. Everybody has their own way of making porridge, but until you compete at Carrbridge, you’ll never know if it’s worthy of the spurtle. </p>

              <img className="img-fluid mb-4 mb-sm-5"
                src={require("../../Images/article18-right-img1.jpg")}
              />

              <div className="row mb-4">
                <div className="col-sm-6">
                  <h4 className="f-lora mb-3 fs-md">Kirkwall Ba’ Game </h4>
                  <p className="mb-3">While many around Scotland are settling down on Christmas Day to relax with presents and turkey, things are very different in Kirkwall. Barriers line the streets, windows are boarded shut and hundreds gather as this Orcadian town gears up for a battle known as the Ba’ Game. </p>
                  <p className="mb-3">There are two sides, Uppies and Doonies, originally split depending on where you were born relative to St Magnus’ Cathedral. The Ba’ is a heavy, corkfilled, leather ball, with each side trying to get it to the opposition’s end. </p>
                  <p className="mb-3">Apart from that, rules are scarce and the physical game is exhausting, lasting an average of five hours. It’s a tradition that dates back at least 300 years and for those from Kirkwall, victory is considered the highest possible honour. </p>
                </div>
                <div className="col-sm-6">
                  <h4 className="f-lora mb-3 fs-md">Scottish Coal Carrying Championship </h4>
                  <p className="mb-3">Fife was once famous for its coalfields and that important part of local heritage is being kept alive today by the Scottish Coal Carrying Championship in Kelty. The competition was inspired by stories of local coal miners running home from the pits in the 1800s after a hard day’s work. </p>
                  <p className="mb-3">Men carry a 50kg bag of coal over a 1,000m distance while women race with a 25kg bag. It’s no easy task and it’s not unusual to see competitors give up before the finish line, especially when faced with the gruelling uphill section known as Hell Hill. </p>
                </div>
              </div>

              <img className="img-fluid mb-4 mb-sm-5"
                src={require("../../Images/article18-right-img2.jpg")}
              />
              <h4 className="f-lora mb-3 fs-md">The World Hickory Open </h4>
              <p className="mb-3">Scotland’s relationship with golf is particularly strong, with St Andrews being home to the oldest course in the world. While the sport marches on into the modern age, not everybody is so keen to follow and so every October, Scotland hosts the World Hickory Open Championships. </p>
              <p className="mb-3">Before the days of carbon fibre and titanium, golf was played with hickory clubs and 20 years ago a World Open Championship was founded, moving from course to course each year. </p>
              <p className="mb-4 mb-sm-5">While modern golf is dominated by big drives with powerful clubs, hickory is the thinking player’s game, with more emphasis on technique and careful planning. It might seem old-fashioned, but this traditional sport is going from strength to strength. </p>

              <img className="img-fluid mb-4 mb-sm-5"
                src={require("../../Images/article18-right-img3.jpg")}
              />
              <h4 className="f-lora mb-3 fs-md">World Stone Skimming Stones Championships </h4>
              <p className="mb-3">Every September, on the tiny island of Easdale, hopeful competitors gather to show off their throwing arms. This is the World Stone Skimming Championships that have taken place off and on here since 1983. </p>
              <p className="mb-3">The fact that these are known as the Slate Islands explains why this tradition takes place here. This was the centre of Scotland’s slate industry, with millions once quarried annually and flooded quarries with perfectly flat surrounding stones make the perfect combination for the sport. </p>
              <p className="mb-4 mb-sm-5">Competitors have three attempts to skim stones as far as possible before sinking, with a minimum of two bounces required. There’s a special award just for locals as well as an Old Tosser category for those of a certain age. </p>

            </div>
          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article18;
